import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "App";
import configureStore from "./store";

import { Auth0Provider } from "@auth0/auth0-react";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import "./styles/dashboard.scss";

const store = configureStore();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.NODE_ENV,
});

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <Auth0Provider
    domain="pickaxe-api.us.auth0.com"
    clientId="44CPkcTzV21HRsDugVXoznmOeN4FgB2Z"
    redirectUri={`${window.location.origin}/sso`}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>
);
